import { createStyles, makeUiStyles } from '../styles/styles';
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles(() =>
  createStyles({
    tooltip: {
      position: 'relative',
      display: 'inline-flex',
      top: 2,
      alignSelf: 'flex-start',
    },
    noWrap: {
      display: 'inline-flex',
      whiteSpace: 'nowrap',
      alignItems: 'center',
      gap: 4,
    },
    labelText: {
      display: 'inline',
    },
  }), { name: 'LabelWithTooltip', index: StylesIndexInjections.UI_MOLECULES });
